import { widgetGlobalName, cdnPath } from './config.json';
import { getTargetScriptInfos } from './sdkHost';
import appendScript, { appendCss } from './jsscript';

const {
  preUrlOfStaticResouce,
} = getTargetScriptInfos();

const sdkExport = { [cdnPath]: `${preUrlOfStaticResouce}/` };

const widgetCaller = (() => {
  let widgetReadyCallbackCalled = false;
  let widgetJSReady = false;
  let outerCallback;

  const runner = fn => (params) => {
    fn(params);
    if (!widgetReadyCallbackCalled && widgetJSReady && outerCallback) {
      widgetReadyCallbackCalled = true;
      outerCallback(window[widgetGlobalName]);
    }
  };

  return {
    setWidgetReady: runner(() => {
      widgetJSReady = true;
    }),
    setCallback: runner((callback) => {
      outerCallback = callback;
    }),
  };
})();

sdkExport.COMMERCEWidget = {
  onReady: widgetCaller.setCallback,
  version: process.env.VERSION,
};
Object.assign(window, sdkExport);

appendScript(`${preUrlOfStaticResouce}/widgets.min.js`, widgetCaller.setWidgetReady);
appendCss(`${preUrlOfStaticResouce}/widgets.css`);
